'use-client';
import FlickrBadgeWidget from '../../FlickrBadgeWidget';
import { WithConsentPolicy } from '../../../../ConsentPolicyWrapper/viewer/ConsentPolicyWrapper';

export default WithConsentPolicy(FlickrBadgeWidget, {
  componentConsentPolicy: { analytics: true },
});
